/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import * as R from 'ramda';
import { useQuery } from '@apollo/client';
import GetSouscriptionWaiverStagesGranteesQuery from '../graphql/queries/GetSouscriptionWaiverStagesGranteesQuery.js';

const useGetSouscriptionWaiverStagesGranteesQuery = (args) => {
  const { data, error, loading, refetch } = useQuery(GetSouscriptionWaiverStagesGranteesQuery, args);

  return {
    error,
    loading,
    refetch,
    getSouscriptionWaiverStagesGrantees: R.omit(['__typename'], data?.getSouscriptionWaiverStagesGrantees_souscription_waiver_stages || {})
  };
};

export default useGetSouscriptionWaiverStagesGranteesQuery;
